<template>
  <div class="base-container__white" v-show="!passwordResetSuccess">
    <div class="pass-reset">
      <img src="@/assets/img/logo-wrap.svg" alt="INFRECT" />
      <div class="mt-60px">
        <h2>新規登録</h2>
      </div>
      <div class="mt-40px">
        <h3>パスワードを設定してください。</h3>
      </div>
      <base-text-field placeholder="パスワード" type="password" :width="360" class="mt-60px" v-model="password1"></base-text-field>
      <base-text-field placeholder="パスワード確認用" type="password" :width="360" class="mt-20px" v-model="password2"></base-text-field>
      <div class="error-message" v-show="errorMessage">
        <span v-if="errorMessage?.password">{{ errorMessage.password[0] }}</span>
        <span v-else-if="errorMessage?.detail === '見つかりませんでした。'">
          パスワードがすでに設定されています。<br />
          <router-link :to="{ name: 'SignIn' }">こちら</router-link>からログインしてください。
        </span>
        <span v-else>{{ errorMessage }}</span>
      </div>
      <div class="error-message" v-show="formErrorMessage">{{ formErrorMessage }}</div>
      <div class="mt-60px"><base-button size="wide" @click="submitPasswordReset">パスワード設定</base-button></div>
    </div>
  </div>
  <div class="base-container__white" v-show="passwordResetSuccess">
    <div class="reset-complete">
      <img src="@/assets/img/logo-wrap.svg" alt="INFRECT" />
      <div class="mt-60px">
        <h2>パスワードの設定完了</h2>
      </div>
      <div class="mt-40px">
        <h3>
          パスワードの設定が完了しました。<br />
          早速ログインしてINFRECTを使ってみましょう！
        </h3>
      </div>
      <div class="mt-60px">
        <router-link :to="{ name: 'SignIn' }">
          <base-button size="wide">ログイン</base-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, toRefs } from "vue";
import BaseButton from "@/components/BaseButton.vue";
import BaseTextField from "@/components/BaseTextField.vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { ForgotPasswordResetParams } from "@/types";

export default defineComponent({
  name: "SignUp",
  components: { BaseButton, BaseTextField },
  setup() {
    const store = useStore();
    store.dispatch("users/forgotPasswordResetInitialize");
    const route = useRoute();
    const router = useRouter();
    let token = "";
    if (typeof route.params.token === "string") {
      token = route.params.token;
    } else {
      router.push({ name: "NotFound" });
    }
    const state = reactive({
      errorMessage: computed(() => store.state.users.errorMessage),
      passwordResetSuccess: computed(() => store.state.users.forgotPasswordResetSuccess),
      formErrorMessage: null as string | null,
      password1: null as string | null,
      password2: null as string | null,
    });
    const submitPasswordReset = () => {
      store.dispatch("users/forgotPasswordResetInitialize");
      if (!state.password1) {
        state.formErrorMessage = "パスワードは必須です";
      } else if (!state.password2) {
        state.formErrorMessage = "パスワード確認用は必須です";
      } else if (state.password1 !== state.password2) {
        state.formErrorMessage = "パスワードと確認用パスワードが違います";
      } else {
        state.formErrorMessage = null;
        const params: ForgotPasswordResetParams = { token: token, password: state.password1 };
        store.dispatch("users/forgotPasswordReset", params);
      }
    };
    return { ...toRefs(state), submitPasswordReset };
  },
});
</script>

<style lang="scss" scoped>
@import "../../src/assets/styles/main";
.pass-reset {
  & h2 {
    color: map-get($colors, "blue400");
  }
  & h3 {
    font-weight: 500;
  }
  text-align: center;
  padding-top: 120px;
}
.reset-complete {
  text-align: center;
  padding-top: 120px;
  & h2 {
    color: map-get($colors, "blue400");
  }
  & h3 {
    font-weight: 500;
  }
  & img {
    width: 160px;
    height: auto;
  }
}
.error-message {
  padding: 20px;
  color: map-get($colors, "accent");
}
</style>
